export
const name: string = "LightingSimpleInVs";

export
const preproc: string = ``;

export
const declaration: string = `
    // the light related code was inspired by http://www.john-chapman.net/content.php?id=3
    struct SLight {
              vec4 position; // in view space when the w component is zero, we have directional light
        lowp  vec3 diffuse;
        lowp  vec3 specular;
        lowp  float enabled;
        lowp  float fixed_pos;
    };

    const      int    MAX_LIGHT_SOURCES = 2;

    // required uniforms
    uniform       float  u_minimal_diffuse_light; // for shadow volumes
    uniform       int    u_lights_count;
    uniform       SLight u_lights[MAX_LIGHT_SOURCES];
`;

export
const varyings: string = `
    varying       vec3   v_simple_diffuse_color;
    varying       vec3   v_simple_specular_color;
`;

export
const implementation: string = `
    // we need to compute directional lighting and simple not directional (only sum of lights) because we decde the
    // lighting type in fragment shader based on texture mapping
    void setVaryingsForLighting0()
    {
         v_simple_diffuse_color = vec3(0.0);
         v_simple_specular_color = vec3(0.0);

        for (int i = 0; i < MAX_LIGHT_SOURCES; i++) {
            if (i < u_lights_count) {
                if (u_lights[i].enabled > 0.5) {
                    if (u_lights[i].position.w > 0.5) {
                        /*if (u_lights[i].spot_exponent != 0.0) { // spot light
                            spot(surface, u_lights[i], results);
                        }
                        else { // point light
                            point(surface, u_lights[i], results);
                        }*/
                    }
                    else { //w == 0.0 -> directional light
                        v_simple_diffuse_color  += u_lights[i].diffuse;
                        v_simple_specular_color += u_lights[i].specular;
                    }
                }
            }
        }
    }

    // we need to compute directional lighting and simple not directional (only sum of lights) because we decde the
    // lighting type in fragment shader based on texture mapping
    void setVaryingsForLighting2(in vec3 aNormal, in vec4 aEyeSpacePosition, in vec4 aClipSpacePosition)
    {
         v_simple_diffuse_color = vec3(0.0);
         v_simple_specular_color = vec3(0.0);

        for (int i = 0; i < MAX_LIGHT_SOURCES; i++) {
            if (i < u_lights_count) {
                if (u_lights[i].enabled > 0.5) {
                    if (u_lights[i].position.w > 0.5) {
                        /*if (u_lights[i].spot_exponent != 0.0) { // spot light
                            spot(surface, u_lights[i], results);
                        }
                        else { // point light
                            point(surface, u_lights[i], results);
                        }*/
                    }
                    else { //w == 0.0 -> directional light
                        v_simple_diffuse_color  += u_lights[i].diffuse;
                        v_simple_specular_color += u_lights[i].specular;
                    }
                }
            }
        }
    }
`;
